import { v4 as uuidv4 } from "uuid";

export default function todosReducer(currentTodos, action) {
  switch (action.type) {
    case "added": {
      const newToDo = {
        id: uuidv4(),
        title: action.payload.title,
        description: "",
        isComplete: false,
      };
      let addedToDos = [...currentTodos, newToDo];
      localStorage.setItem("todos", JSON.stringify(addedToDos));
      return addedToDos;
    }
    case "updated": {
      const updatedToDos = currentTodos.map((task) => {
        if (action.payload.id == task.id) {
          return {
            ...task,
            title: action.payload.title,
            description: action.payload.description,
          };
        } else {
          return task;
        }
      });
      localStorage.setItem("todos", JSON.stringify(updatedToDos));
      return updatedToDos;
    }
    case "deleted": {
      const filtersToDos = currentTodos.filter((task) => {
        return action.payload.id != task.id;
      });
      localStorage.setItem("todos", JSON.stringify(filtersToDos));
      return filtersToDos;
    }
    case "checked": {
      const completedToDos = currentTodos.map((task) => {
        if (action.payload.id == task.id) {
          const updatedTodos = { ...task, isComplete: !task.isComplete };
          return updatedTodos;
        }
        return task;
      });
      localStorage.setItem("todos", JSON.stringify(completedToDos));
      return completedToDos;
    }
    case "get": {
      let storageToDos = JSON.parse(localStorage.getItem("todos")) ?? [];
      return storageToDos;
    }
    default: {
      throw Error("Unknown Action", action.type);
    }
  }
}
